export default {"src":"/_next/static/media/Featured1.fe8e6ccc.svg","height":56,"width":56};